import { render } from "./ExamsAside.vue?vue&type=template&id=dc28f180&scoped=true"
import script from "./ExamsAside.vue?vue&type=script&lang=js"
export * from "./ExamsAside.vue?vue&type=script&lang=js"

import "./ExamsAside.vue?vue&type=style&index=0&id=dc28f180&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc28f180"]])

export default __exports__